import React from 'react';
import { Box, Typography } from '@mui/material';
import { Build as BuildIcon } from '@mui/icons-material';
import { useSettings } from '../context/SettingsContext';

function MaintenanceBanner({ message }) {
  const { maintenance } = useSettings();
  if (!maintenance) return null;

  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: { xs: 2, md: 3 },
        py: 1.5,
        backgroundColor: '#fff3e0',
        borderBottom: '2px solid #f57c00',
        color: '#7a3e00',
      }}
    >
      <BuildIcon sx={{ fontSize: 22, color: '#f57c00', flexShrink: 0 }} />
      <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.4 }}>
        {message || 'The site is currently undergoing maintenance. Some features are temporarily unavailable and any changes may not be saved. Please check back shortly.'}
      </Typography>
    </Box>
  );
}

export default MaintenanceBanner;
